function formOptions(defaultOpts) {
  return defaultOpts;
}
export {
  formOptions
};
//# sourceMappingURL=formOptions.js.map
